import { render, staticRenderFns } from "./VoiceIcon.vue?vue&type=template&id=5ed215f6&"
import script from "./VoiceIcon.vue?vue&type=script&lang=js&"
export * from "./VoiceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports